module.exports = __webpack_public_path__ + "static/media/EGP30.48832ecf.jpg";